import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getAllActivityLogs } from "./services/logs.services";
import { ILog, ILogsInitialState } from "./logsModel";

const initialState: ILogsInitialState = {
  loading: false,
  error: "",
  LogsList: [],
  LogsFilterDetail: {
    FromDate: "",
    ToDate: "",
    Key: "",
  },
};

const logsSlice = createSlice({
  name: "logs",
  initialState,
  reducers: {
    setLogsFilterDetails: (state, action) => {
      state.LogsFilterDetail = action.payload;
    },
    clearLogsFilterDetails: (state) => {
      state.LogsFilterDetail = initialState.LogsFilterDetail;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getAllActivityLogs.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActivityLogs.fulfilled,
      (state, action: PayloadAction<ILog[]>) => {
        state.loading = false;
        state.LogsList = action.payload || [];
      }
    );
    builder.addCase(getAllActivityLogs.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.LogsList = [];
    });
  },
});

export const { clearLogsFilterDetails, setLogsFilterDetails } =
  logsSlice.actions;
export default logsSlice.reducer;
